module.exports = __webpack_public_path__ + "img/bg.9b395f1.png";